import { lazyLoad } from 'utils/loadable';

export const NewsCategorySortListPage = lazyLoad(
  () => import('./index'),
  module => module.NewsCategorySortListPage,
);
